import React, { useEffect, useState, useCallback } from "react";
import BookingsTableComponent from "../../component/bookingsTableComponent/BookingsTableComponent";
import { useSelector } from "react-redux";
import services from "../../services/services";
import { Pagination } from "@mui/material";

const Bookings = () => {
  const { adminPermission } = useSelector((state: any) => state.counter);
  const [allBooking, setAllBooking] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const pageLimit = 15;

  const fetchBookings = async (pageNo: number, search: string = "") => {
    setLoading(true);
    try {
      const res = await services.getBookings({
        page: pageNo,
        limit: pageLimit,
        search,
      });
      const { data, pagination } = res.data;
      setAllBooking(data);
      setTotalPages(pagination.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings(1, searchTerm);
  }, [searchTerm]);

  const handleSearch = () => {
    setCurrentPage(0);
    setSearchTerm(searchInput);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleClearSearch = () => {
    setSearchInput("");
    setCurrentPage(0);
    setSearchTerm("");
  };

  if (adminPermission?.is_admin == 2 && !adminPermission?.bookings) {
    return (
      <h1 className="text-3xl font-openSans font-bold text-aqua items-center flex justify-center h-[80vh]">
        {" "}
        You don't have permission
      </h1>
    );
  }

  const handlePageClick = ({ selected }: { selected: number }) => {
    setCurrentPage(selected);
    fetchBookings(selected + 1, searchTerm);
  };

  return (
    <div>
      <div className="flex px-12 w-full justify-between items-center mt-4">
        <div className="flex items-center gap-2">
          <input
            type="text"
            placeholder="Search by name, email, phone, or tour..."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={handleKeyDown}
            className="border border-gray-300 rounded-md px-4 py-2 w-80 outline-none focus:border-aqua"
          />
          <button
            onClick={handleSearch}
            className="bg-aqua text-white px-4 py-2 rounded-md font-openSans"
          >
            Search
          </button>
          {searchTerm && (
            <button
              onClick={handleClearSearch}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md font-openSans"
            >
              Clear
            </button>
          )}
        </div>
      </div>
      {loading ? (
        <div className="flex w-full justify-center mt-8">
          <h1 className="text-aqua text-3xl">Loading...</h1>
        </div>
      ) : (
        <div className="mt-6">
          {allBooking?.length ? (
            <BookingsTableComponent allUser={allBooking} />
          ) : (
            <div className="w-full h-[20vh] flex justify-center items-center">
              <h2 className="text-center text-aqua font-bold font-openSans w-full text-4xl">
                {"No Bookings Available "}
              </h2>
            </div>
          )}
        </div>
      )}
      {allBooking?.length !== 0 && (
        <div className="flex justify-center mt-6 mb-6">
          <Pagination
            count={totalPages || 1}
            page={currentPage + 1}
            onChange={(event, page) => handlePageClick({ selected: page - 1 })}
            siblingCount={3}
            boundaryCount={2}
            variant="outlined"
            shape="rounded"
            size="large"
            color={"primary"}
          />
        </div>
      )}
    </div>
  );
};

export default Bookings;
